import React from "react";
import "./style.sass";
import assets from "../../../assets";
import { ROUTE_DASHBOARD } from "../../../route/communicative";
import { useNavigate } from "react-router-dom";

const CorrectIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#16A34A" strokeWidth="2" />
    <path d="M8 12.5l2.5 2.5L16 9" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const VocabIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M3 17l5-5 4 4 8-8" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 7h4v4" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AccuracyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="#EA580C" strokeWidth="2" />
    <circle cx="12" cy="12" r="4.5" stroke="#EA580C" strokeWidth="2" />
    <circle cx="12" cy="12" r="1" fill="#EA580C" />
  </svg>
);

const RefreshIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 4v5h5M20 20v-5h-5M5.5 9a7 7 0 0112.6-2.5M18.5 15a7 7 0 01-12.6 2.5"
      stroke="#FFFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const QuizComplete=({
  correct = 1,
  total = 5,
  vocabularyScore = 20,
  accuracyScore = 20,
  onTryAgain = () => {},
}) => {
    const navigate = useNavigate();

  const Header = ({ content }) => (
  <header className="voc_header">
    <div className="voc_header_left">
      <img src={assets.ic_logo} alt="Rovian AI" className="logo" />
      <span className="logo_title">Rovian AI</span>
    </div>
    {content}
  </header>
);

  return (
    <div className="quiz-complete">
      <Header
        content={
          <div className="back_link" onClick={() => navigate(ROUTE_DASHBOARD)}>
            <img
              src={assets.ic_back_arrow || ""}
              alt=""
              style={{ transform: "rotate(0deg)", width: "12px" }}
            />{" "}
            Dashboard
          </div>
        }
      />
      <div className="quiz-complete__sparkles" aria-hidden="true">
        <span className="sparkle sparkle--1">✦</span>
        <span className="sparkle sparkle--2">✦</span>
        <span className="sparkle sparkle--3">✦</span>
        <span className="sparkle sparkle--4">✦</span>
      </div>

      <div className="quiz-complete__trophy" role="img" aria-label="trophy">
        🏆
      </div>

      <h2 className="quiz-complete__title">Vocabulary Quiz Complete!</h2>
      <p className="quiz-complete__subtitle">Keep Practicing!</p>
      <p className="quiz-complete__description">
        You got {correct} out of {total} questions correct. Review the daily words and try again.
      </p>

      <div className="quiz-complete__stats">
        <div className="stat-card stat-card--green">
          <div className="stat-card__icon">
            <CorrectIcon />
          </div>
          <p className="stat-card__label">Correct Answers</p>
          <p className="stat-card__value">
            {correct}/{total}
          </p>
        </div>

        <div className="stat-card stat-card--purple">
          <div className="stat-card__icon">
            <VocabIcon />
          </div>
          <p className="stat-card__label">Vocabulary Score</p>
          <p className="stat-card__value">{vocabularyScore}%</p>
        </div>

        <div className="stat-card stat-card--orange">
          <div className="stat-card__icon">
            <AccuracyIcon />
          </div>
          <p className="stat-card__label">Accuracy Score</p>
          <p className="stat-card__value">{accuracyScore}%</p>
        </div>
      </div>

      <button className="quiz-complete__try-again" onClick={onTryAgain} type="button">
        <RefreshIcon />
        <span className="try-again">Try Again</span>
      </button>
    </div>
  );
}
